import { JSX, useEffect, useMemo, useState } from "react";

import { Alert, LinearProgress } from "@mui/material";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { useLocationsDataQuery } from "src/api/locationQueries.api";
import Pages from "src/constants/pages.enum";
import { getAvailablePagesBasedOnLocationStructure } from "src/lib/locationTree.helper";
import { getAppRolesFromUser } from "src/lib/user.helper";

function Redirect(): JSX.Element {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [error, setError] = useState<string>();

  const { data: locations } = useLocationsDataQuery();

  const userAppRoles: string[] = useMemo(() => getAppRolesFromUser(user), [user]);

  useEffect(() => {
    if (locations?.value) {
      if (locations.value.length === 0) {
        setError("No locations set for user! Please contact your ASE Spokesperson to configure your account correctly.");
      } else if (userAppRoles.length === 0) {
        setError(
          "No roles set for your user, your user is probably incorrectly configured. Pleae contact your ASE Spokespseron to configure your account correctly."
        );
      } else {
        const availablePages: Pages[] = getAvailablePagesBasedOnLocationStructure(locations.value, userAppRoles);
        if (availablePages.includes(Pages.CenterRegionDashboard)) {
          navigate("/center-region-dashboard", { replace: true });
        } else if (availablePages.includes(Pages.CenterDashboard)) {
          navigate("/center-dashboard", { replace: true });
        } else if (availablePages.includes(Pages.ShopRegionDashboard)) {
          navigate("/shop-region-dashboard", { replace: true });
        } else if (availablePages.includes(Pages.ShopDashboard)) {
          navigate("/shop-dashboard", { replace: true });
        } else if (availablePages.includes(Pages.StationRegionDashboard)) {
          navigate("/station-region-dashboard", { replace: true });
        } else if (availablePages.includes(Pages.StationDashboard)) {
          navigate("/station-dashboard", { replace: true });
        } else if (availablePages.includes(Pages.InsightsPage)) {
          navigate("/extended-analytics", { replace: true });
        } else if (availablePages.includes(Pages.DocumentPage)) {
          navigate("/files", { replace: true });
        }
      }
    }
  }, [locations, navigate, userAppRoles]);

  if (error) {
    return <Alert severity='warning'>{error}</Alert>;
  }

  return <LinearProgress />;
}

export default Redirect;
